import { useEffect } from "react";

export default function useSEO(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
      let og = document.querySelector('meta[property="og:title"]');
      if (og && title) og.setAttribute("content", title);
    }
  }, [title, description]);
}
